module.exports = __webpack_public_path__ + "img/59cd336.jpg";